import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import Seo from '../components/common/Seo';

const NotFoundPage = () => {
  return (
    <main className="tech-grid min-h-[70vh] bg-[#06101f] px-4 py-20 text-white sm:px-6 lg:px-8" data-testid="not-found-page">
      <Seo
        title="404 Not Found | LEION Engineering"
        description="The requested page could not be found. Browse LEION Engineering weighbridges, industrial scales, software and support services."
        path="/404"
        noindex
      />
      <div className="mx-auto max-w-4xl">
        <p className="section-eyebrow">404 Not Found</p>
        <h1 className="font-['Manrope'] mt-4 text-4xl font-bold uppercase tracking-tight md:text-6xl">
          This LEION page does not exist.
        </h1>
        <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
          Use the product catalogue, sitemap, or agent guidance file to find the right weighbridge, truck scale, platform scale, indicator, software, support, or contact page.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/products">
            <Button className="rounded-sm bg-[#1E40AF] px-6 py-4 font-bold uppercase tracking-wider text-white hover:bg-[#2563EB]">
              View Products
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <a href="/sitemap.xml">
            <Button variant="outline" className="rounded-sm border-2 border-[#60A5FA] px-6 py-4 font-bold uppercase tracking-wider text-[#60A5FA] hover:bg-[#60A5FA] hover:text-[#08152b]">
              Sitemap
            </Button>
          </a>
          <a href="/llms.txt">
            <Button variant="outline" className="rounded-sm border-2 border-[#60A5FA] px-6 py-4 font-bold uppercase tracking-wider text-[#60A5FA] hover:bg-[#60A5FA] hover:text-[#08152b]">
              llms.txt
            </Button>
          </a>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
